export default function PublishIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M5 4v2h14V4H5m0 10h4v6h6v-6h4l-7-7-7 7z" />
		</svg>
	)
}